define('viewModels/privileged/qm/EmailDetailsView',[
    'jquery',
    'moment',
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'services/qm/qualityBroadcast',
    'services/loggingService',
    'viewModels/privileged/qm/util/BroadCastEnum',
    'viewModels/ViewModel',
    'viewModels/privileged/qm/RecordingRestoreDetailsView',
    'viewModels/privileged/qm/util/FileStateEnum'
], function ($,
             moment,
             ko,
             _,
             Promise,
             qualityBroadcast,
             LOG,
             BroadcastEnum,

             ViewModel,
             RecordingRestoreDetailsView,
             FileStateEnum
) {
    'use strict';

    return ViewModel.extend(function (recording, recordingRestoreDetails, options, conversationObservable) {
        var self = this;
        self.emailTranscript = recording().emailTranscript;
        self.displayEmail = recording().fileState === FileStateEnum.AVAILABLE;
        self.recordingRestoreDetails = recordingRestoreDetails;
        self.conversation = ko.isObservable(conversationObservable) ? conversationObservable : ko.observable(conversationObservable);
        self.emailMessages = ko.observableArray(
            _.map(self.emailTranscript ? self.emailTranscript : [{}], function(email) {

                email.showEmail = ko.observable(options && options.isLast);
                email.toggleEmail = function() {
                    email.showEmail(!email.showEmail());
                };
                // TODO find a better fix for this
                // if there is no subject in the payload, set
                // to empty string to properly render attachment
                if(!email.hasOwnProperty('subject')) {
                  email.subject = '';
                }

                email.autoGenerated = checkEmailMessageForAutoGenerated(email.id);

                email.showText = ko.observable(!email.htmlBody);
                email.toggleText= function(){
                    email.showText(!email.showText());
                };

                if(email.attachments) {
                    try {
                        try {
                            email.htmlBody = getEmailBodyWithImage(email.htmlBody, email.attachments);
                        } catch(err) {
                            // Try wrapping it in a div
                            LOG.warn("Failed to get email body with images. Wrapping in div and trying again", err);
                            email.htmlBody = getEmailBodyWithImage("<div>" + email.htmlBody + "</div>", email.attachments);
                        }
                    } catch(err) {
                        LOG.warn("Email client supplied an html syntax error.", err);
                    }

                    _.map(email.attachments, function (attachment) {
                        if (!attachment.name) {
                            attachment.name = ko.i18n.renderString("playback.email.view.unnamed");
                        }
                    });
                }
                if(email.time) {
                    email.time = new Date(email.time);
                }
                email.highlight = ko.observable(false);
                return email;
            })
        );

        function checkEmailMessageForAutoGenerated(messageId) {
            if (!self.conversation()) {
                return false;
            }

            return _.some(self.conversation().participants(), function(participant) {
                return _.some(participant.emails, function(email) {
                    if (email.messageId === messageId) {
                        return email.autoGenerated;
                    }
                });
            });
        }

        function getEmailBodyWithImage(htmlBodyString, attachments){
            if (htmlBodyString) {
                var htmlBody = $(htmlBodyString);
                if (htmlBody.length !== 1) {
                    htmlBody = $("<div>" + htmlBodyString + "</div>");
                }

                var isRootTagImg = htmlBody[0].tagName.toLowerCase() === "img";
                var imageArray = !isRootTagImg ? htmlBody.find('img') : [htmlBody[0]];
                if (imageArray && imageArray.length > 0 && attachments && attachments.length > 0){
                    _.each(imageArray, function(image){
                        var src = getCorrectSourceUrl(attachments, image.src);
                        if (src){
                            image.src = src.contentPath;
                        }

                    });
                }
                return !isRootTagImg ? htmlBody.html() : htmlBody[0].outerHTML;
            }
            return htmlBodyString;
        }

        self.headerText = function () {
            if (recording().fileState === FileStateEnum.DELETED) {
                return 'playback.email.deleted.title';
            }
            if (recording().fileState === FileStateEnum.ARCHIVED || !self.emailTranscript) {
                return 'playback.email.archived.title';
            }
            return 'playback.email.view.from';
        };

        function getCorrectSourceUrl(attachments, srcId){
            return _.find(attachments, function(attachment){
                return srcId.indexOf(attachment.attachmentId) > -1;
            });
        }

        qualityBroadcast.subscribe(recording().conversationId, BroadcastEnum.HANDLE_EMAIL_EVALUATION_TOPIC, function(message){
            _.each(self.emailMessages(), function(email){
                if (message.resourceId !== recording().sessionId && email.showEmail() && email.highlight() && !message.noSessionId){
                    email.showEmail(false);
                    email.highlight(false);
                }
                if (message.resourceId === recording().sessionId){
                    email.showEmail(true);
                    email.highlight(true);
                }
                if (message.noSessionId && email.highlight()){
                    email.highlight(false);
                }
            });
        });
    });
});

